import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'filterByIntersect',
    standalone: false
})
export class FilterByIntersectPipe implements PipeTransform {
  transform(items: any, intersectArray: any): any {
    if (!items || !intersectArray) {
      return items;
    }
    if (intersectArray.indexOf('backup') === -1 && items.indexOf('backup') > -1) {
      items.splice(items.indexOf('backup'), 1);
    }
    if (intersectArray.indexOf('optimizer') === -1 && items.indexOf('optimizer') > -1) {
      items.splice(items.indexOf('optimizer'), 1);
    }
    return items;
  }
}
